/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import TextArea from "@insite/mobius/TextArea/TextArea";
import MultiSelectDropdown, { Option } from "@tKgpco/Components/MultiSelectDropdown";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import { Accessorial, Accessorials } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";
import { useWORContext } from "@tKgpco/Widgets/WOR/WORCheckoutReviewSubmitPage";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => ({
    accessorials: state.KGPState.customAccessorials.carrierShipAccessorial,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;
export interface WORAccessorialsStyles {
    accessorialsCheckbox?: CheckboxProps;
    accessorialsCheckboxGroup?: CheckboxGroupComponentProps;
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    dateGridItem?: GridItemProps;
}
const worAccessorialsStyles: WORAccessorialsStyles = {
    gridContainer: {
        gap: 5,
        css: css`
            border-radius: 4px;
            padding: 10px;
            border: 2px solid #f1f6fb;
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    dateGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
};

const styles = worAccessorialsStyles;

const WORAccessorialsCheckbox: React.FunctionComponent<Props> = ({ fields, accessorials }: Props) => {
    const { worData, worDispatch } = useWORContext();
    const [selectedAccessorials, setSelectedAccessorials] = useState<Option[]>([]);

    const handleDropdownChange = (option: Option) => {
        const isSelected =
            selectedAccessorials &&
            selectedAccessorials.length > 0 &&
            selectedAccessorials.filter(val => val?.value.indexOf(option?.value) !== -1).length > 0;

        let status: Option[] = selectedAccessorials && selectedAccessorials.length > 0 ? [...selectedAccessorials] : [];
        if (isSelected) {
            status = selectedAccessorials!.filter(val => option.value !== val.value);
        } else {
            status.push(option);
        }
        if (status.length > 0) {
            setSelectedAccessorials(status);

            const filteredTICode: string[] = [];
            accessorials?.forEach(data => {
                status.forEach(acc => {
                    if (acc.value === data.id) {
                        filteredTICode.push(data.tI_Code);
                    }
                });
            });

            worDispatch({ type: "SET_DATA", payload: { ShipmentAccessorials: filteredTICode } });
        } else {
            setSelectedAccessorials([]);
        }
    };

    const options = accessorials || [];
    const uniqueOptions = new Map<string, string[]>();
    for (const option of options) {
        const accessorialsOption = uniqueOptions.get(option.name) || [];
        accessorialsOption.push(option.id);
        uniqueOptions.set(option.name, accessorialsOption);
    }

    const dropDownOptions: Option[] = Array.from(uniqueOptions, ([name, values]) => ({ name, values })).map(option => ({
        value: option.values.join(","),
        label: option.name,
    }));

    const selectedOptions: Option[] =
        selectedAccessorials && selectedAccessorials.length > 0
            ? selectedAccessorials.map(val => ({
                  value: val.value,
                  label: dropDownOptions.find(opt => opt.value === val.value)?.label || "",
              }))
            : [];

    if (worData?.selectedShipVia?.isPickUp) {
        return null;
    }

    return (
        <GridContainer
            offsetCss={css`
                margin-bottom: 2.5rem;
                max-width: 100% !important;
            `}
        >
            <GridItem {...styles.dateGridItem}>
                <MultiSelectDropdown
                    label="Premium Shipping Services "
                    handleOptionClick={handleDropdownChange}
                    options={dropDownOptions}
                    selectedOptions={selectedOptions}
                    placeHolder="Select Accessorials"
                />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(WORAccessorialsCheckbox),
    definition: {
        group: "Basic",
        icon: "heading",
    },
};

export default widgetModule;
